import React from 'react';
import { IconProps } from '../IconProps';


// https://github.com/dh1tw/iso-country-flags-svg-collection-1/blob/master/svg/country-4x3/nl.svg?short_path=be962d3
export const En: React.FC<IconProps> = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480" width={props.width} height={props.height} version="1" y="0" x="0" className={props.className}>
            <g id="flag" clipPath="url(#clipPath8673)" transform="matrix(.93750 0 0 .93750 80 .0000026825)">
                <g id="g578" strokeWidth="1pt" transform="matrix(17.067 0 0 17.067 -256 -0.0000024)">
                    <rect id="rect124" height="30" width="60" y="0" x="0" fill="#006"/>
                    <g id="g584">
                        <path id="path146" d="m0 0v3.3541l53.292 26.646h6.708v-3.354l-53.292-26.646h-6.708zm60 0v3.354l-53.292 26.646h-6.708v-3.354l53.292-26.646h6.708z" fill="#fff"/>
                        <path id="path136" d="m25 0v30h10v-30h-10zm-25 10v10h60v-10h-60z" fill="#fff"/>
                        <path id="path141" d="m0 12v6h60v-6h-60zm27-12v30h6v-30h-6z" fill="#c00"/>
                        <path id="path150" d="m0 30 20-10h4.472l-20 10h-4.472zm0-30 20 10h-4.472l-15.528-7.7639v-2.2361zm35.528 10 20-10h4.472l-20 10h-4.472zm24.472 20-20-10h4.472l15.528 7.764v2.236z" fill="#c00"/>
                    </g>
                </g>
            </g>
        </svg>
    )
};
